import { EventEmitter } from '@angular/core';
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.id = '';
        this.loading = false;
        this.loadingType = 'spin';
        this.body = '';
        this.size = 'medium';
        this.type = 'btn-primary btn-siguiente';
        this.onClick = new EventEmitter();
        this.spin = this.loadingType === 'spin';
        this.isFullWidth = false;
    }
    ButtonComponent.prototype.onClickHandler = function (event) {
        event.stopPropagation();
        this.onClick.emit(event);
    };
    return ButtonComponent;
}());
export { ButtonComponent };
